import { useEffect, useState } from "react";
import { StopCircle, Gauge } from "lucide-react";
import { toast } from "sonner";
import apiClient, { getErrorMessage } from "@/lib/apiClient";
import { AdminHeader, TableWrap, Th, Td, Tr, StatusChip, Spinner, EmptyRow } from "@/components/admin/ui";
import { fmtLap } from "@/pages/MySessions";

export default function AdminSimSessions() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => apiClient.get("/admin/simhub/sessions").then(({ data }) => setSessions(data)).catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const end = async (id) => {
    try { await apiClient.post(`/admin/simhub/sessions/${id}/end`); toast.success("Session ended"); load(); }
    catch (err) { toast.error(getErrorMessage(err, "Failed")); }
  };

  if (loading) return <Spinner label="Loading sessions" />;

  const active = sessions.filter((s) => s.status === "active").length;

  return (
    <div>
      <AdminHeader title="Sim Sessions" subtitle={`${sessions.length} sessions · ${active} live now`} />
      <TableWrap>
        <thead><Tr><Th>Driver</Th><Th>Station</Th><Th>Track / Car</Th><Th>Best Lap</Th><Th>Laps</Th><Th>Top Speed</Th><Th>Started</Th><Th>Status</Th><Th></Th></Tr></thead>
        <tbody>
          {sessions.length === 0 ? <EmptyRow colSpan={9} text="No sim sessions yet" /> : sessions.map((s) => (
            <Tr key={s.id}>
              <Td>
                <p className="text-white font-semibold" data-testid={`sim-driver-${s.id}`}>{s.user_name || "—"}</p>
                <p className="text-slate-500 text-xs">{s.user_email}</p>
              </Td>
              <Td className="text-slate-300">{s.station_name}</Td>
              <Td className="text-slate-400">{s.track || "—"}<span className="text-slate-600"> / </span>{s.car || "—"}</Td>
              <Td style={{ color: "#00ff9d" }}>{fmtLap(s.best_lap_ms)}</Td>
              <Td>{s.lap_count || 0}</Td>
              <Td>{s.top_speed ? `${s.top_speed} km/h` : "—"}</Td>
              <Td className="text-slate-400 text-xs">{new Date(s.started_at).toLocaleString()}</Td>
              <Td><StatusChip status={s.status === "active" ? "active" : "completed"} /></Td>
              <Td>{s.status === "active" && <button onClick={() => end(s.id)} className="text-slate-400 hover:text-pink-400" title="End session" data-testid={`sim-end-${s.id}`}><StopCircle className="w-4 h-4" /></button>}</Td>
            </Tr>
          ))}
        </tbody>
      </TableWrap>
    </div>
  );
}
